<template>
	<div class='comments-block'>
		<div class='title-block'>
			<span class='title'>Поле для комментариев</span>
			<div class='control-block'>
				<custom-p-checkbox :value='showComment' @input='onshowCommentChange' label='Добавить комментарий на титульный лист акта' :disabled='!actLpoIsDraft'/>

				<div class='btn-row-block'>
					<button @click='reset' :disabled='!actLpoIsDraft'>Отмена</button>
					<button @click='save' :disabled='!actLpoIsDraft'>Сохранить</button>
				</div>
			</div>
		</div>
		<textarea :placeholder='placeholder' v-model='comment' class='text-area' :disabled='!actLpoIsDraft'></textarea>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'LeaseDataCommentsBlock',
		data: () => ({
			placeholder: 'Поле для комментариев',
			comment: null,
		}),
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			leaseComment() {
				return this.selectedLease ? this.selectedLease.comment : null;
			},

			showComment() {
				return this.selectedLease ? (this.selectedLease.show_comment === 't' ? true : false) : false;
			},

			...mapState({
				selectedLease: state => state.actLpo.lease['lease'],
			})
		},
		watch: {
			leaseComment() {
				this.reset();
			}
		},

		methods: {
			onshowCommentChange(event) {
				// const value = event.target.checked;


				const valueList = [
					{
						field: 'show_comment',
						value: event
					}
				];

				this.saveGeneralValue(valueList).then(res => {
					return this.updateLease();
				});
			},

			save() {
				console.log('save');
				const valueList = [
					{
						field: 'comment',
						value: this.comment
					}
				];

				this.saveGeneralValue(valueList).then(res => {
					return this.updateLease();
				});
			},

			reset() {
				if (this.selectedLease) {
					this.comment = this.selectedLease.comment;
				}
				
			},

			...mapActions('actLpo', [
				'updateLease',
				'saveGeneralValue'
			])
		},
		created() {
			this.reset();
		}
	};
</script>

<style scoped>
	.title-block {
		margin-bottom: 10px;
	}

	.title {
		font-size: 1.3rem;
		font-weight: bold;
		color: #444;
	}

	.text-area {
		width: 100%;
		height: 100px;
		padding: 20px;
		border-radius: 5px;
	}

	.control-block::after {
		display: table;
		content: '';
		clear: both;
	}

	.btn-row-block {
		float: right;
	}
	.btn-row-block > button:first-child {
		margin-right: 10px;
	}
</style>